export default "__VITE_ASSET__B19TXzNI__"